import React from 'react';
import { Shield, Award, FileCheck, AlertTriangle } from 'lucide-react';
import { trustPoints } from '../data/mock';

const iconMap = {
  0: Shield,
  1: Award,
  2: FileCheck,
  3: AlertTriangle
};

const TrustSection = () => {
  return (
    <section id="trust" className="bg-neutral-950 py-24 lg:py-32 relative overflow-hidden">
      {/* Background accent */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-electric-yellow/50 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-electric-yellow/50 to-transparent" />
      
      <div className="max-w-[1400px] mx-auto px-6 lg:px-[7.6923%]">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left content */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-[2px] bg-electric-yellow" />
              <span className="text-electric-yellow text-sm font-medium tracking-widest uppercase">
                Why Choose Us
              </span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              Built on Trust.<br />
              <span className="text-electric-yellow">Powered by Excellence.</span>
            </h2>
            
            <p className="text-xl text-neutral-400 leading-relaxed mb-8">
              For over 15 years, Nexline Electrical has been the trusted choice for 
              homeowners, builders, and businesses across Canada. Our commitment to 
              safety, quality, and professionalism sets us apart.
            </p>

            <div className="flex items-center gap-6">
              <div className="flex -space-x-2">
                {[1, 2, 3, 4].map((i) => (
                  <div 
                    key={i}
                    className="w-10 h-10 rounded-full bg-neutral-800 border-2 border-black flex items-center justify-center"
                  >
                    <span className="text-xs text-white font-medium">
                      {['JD', 'MK', 'RS', 'AL'][i - 1]}
                    </span>
                  </div>
                ))}
              </div>
              <div>
                <div className="text-white font-semibold">500+ 5-Star Reviews</div>
                <div className="text-neutral-500 text-sm">Trusted by thousands of Canadians</div>
              </div>
            </div>
          </div>

          {/* Right content - Trust points */}
          <div className="grid grid-cols-2 gap-4">
            {trustPoints.map((point, index) => {
              const Icon = iconMap[index];
              return (
                <div 
                  key={point.id}
                  className="group bg-black border border-white/5 p-6 hover:border-electric-yellow/30 transition-all duration-500"
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-electric-yellow/10 mb-4 group-hover:bg-electric-yellow transition-all duration-400">
                    <Icon 
                      size={24} 
                      className="text-electric-yellow group-hover:text-black transition-colors duration-400"
                    />
                  </div>
                  <h3 className="text-lg font-semibold text-white mb-2">
                    {point.title}
                  </h3>
                  <p className="text-sm text-neutral-500 leading-relaxed">
                    {point.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
